module.exports = __webpack_public_path__ + "static/media/5-10.0d48e829.webp";